module.exports = __webpack_public_path__ + "img/mainbanner-background.bd52dcc7.png";